<template>
  <div class="mains">
    <div class="campus">
      内容管理
      <span></span>
      <span>PPT管理</span>
      <span></span>
      我的PPT
    </div>

    <div class="xiaoqu">
      <el-card>
        <!-- 搜索栏 -->
        <div class="search-bar">
          <el-input
            v-model="query.title"
            placeholder="按 PPT 名称搜索"
            clearable
            style="width: 240px"
            @keyup.enter.native="handleSearch"
          ></el-input>
          <el-button type="primary" style="margin-left: 10px" @click="handleSearch">查询</el-button>
        </div>
        <div style="font-size: 12px; color: #999; margin-top: 8px">
          本页仅管理已转换的项目（预览检查 / 编辑 / 导出 / 删除）；新 .pptx 转换请从左侧菜单进入「PPT转换」页。
        </div>

        <!-- 表格（区域内部滚动，分页常驻底部） -->
        <div class="table-wrap">
        <el-table :data="list" border stripe style="margin-top: 14px">
          <el-table-column prop="title" label="PPT 名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="类型" width="180">
            <template slot-scope="scope">
              <el-tag v-if="pageAnimCount(scope.row.pagesJson)" size="mini" type="warning">动画 {{ pageAnimCount(scope.row.pagesJson) }}</el-tag>
              <el-tag v-if="pageVideoCount(scope.row.pagesJson)" size="mini" type="primary" style="margin-left: 4px">视频 {{ pageVideoCount(scope.row.pagesJson) }}</el-tag>
              <span v-if="!pageAnimCount(scope.row.pagesJson) && !pageVideoCount(scope.row.pagesJson)" style="color: #c0c4cc">普通</span>
            </template>
          </el-table-column>
          <el-table-column label="页数" width="90">
            <template slot-scope="scope">
              {{ pageCount(scope.row.pagesJson) }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="160">
            <template slot-scope="scope">{{ formateDate(scope.row.update_date) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="400" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handlePreview(scope.row)">预览检查</el-button>
              <el-button size="mini" type="warning" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="success" icon="el-icon-download" title="下载受保护版" @click="handleExportProtected(scope.row)">受保护版</el-button>
              <el-button size="mini" type="primary" icon="el-icon-download" title="下载验证版" @click="handleExportVerify(scope.row)">验证版</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>

        <!-- 分页 -->
        <el-pagination
          style="margin-top: 14px; text-align: right; flex-shrink: 0"
          background
          layout="total, prev, pager, next"
          :total="total"
          :current-page.sync="query.pageNum"
          :page-size="query.pageSize"
          @current-change="loadData"
        ></el-pagination>
      </el-card>
    </div>

    <!-- 预览检查：全部页面缩略图网格，点击任意页放大查看（不依赖发布） -->
    <el-dialog
      title="PPT 预览检查（全部页面 · 点击任意页放大查看）"
      :visible.sync="previewVisible"
      width="92%"
      top="3vh"
    >
      <div class="preview-grid" v-loading="previewLoading">
        <div
          v-for="(p, i) in previewPages"
          :key="p.id"
          class="preview-th"
          title="点击放大查看"
          @click="previewBig(i)"
        >
          <img :src="p.img" :alt="'第' + (i + 1) + '页'" loading="lazy">
          <span class="preview-no">{{ i + 1 }}</span>
        </div>
        <div v-if="!previewLoading && previewPages.length === 0" class="preview-empty">
          该项目没有可预览的渲染页面，请重新导入 .pptx 转换。
        </div>
      </div>
    </el-dialog>

    <!-- 大图查看（点击缩略图后放大，可翻页） -->
    <el-dialog :visible.sync="bigVisible" width="86%" top="2vh" :show-close="true">
      <div class="big-stage">
        <img :src="bigImg" class="big-img" alt="大图预览">
      </div>
      <div class="big-nav">
        <el-button size="small" icon="el-icon-arrow-left" @click="previewNav(-1)">上一页</el-button>
        <span class="big-no">第 {{ bigIndex + 1 }} / {{ previewPages.length }} 页</span>
        <el-button size="small" @click="previewNav(1)">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
    </el-dialog>

    <!-- 导出设置（水印文字/位置模式），确认后按所选类型导出 -->
    <export-wm-dialog ref="wmDialog" v-model="wmDialogVisible" :preset-text="wmPreset" @confirm="onWmConfirm" />
  </div>
</template>

<script>
import { getPptProjectPage, deletePptProject, getPptProjectById } from '@/api/ppt'
import { exportProtectedHtml, exportVerifyHtml } from '@/utils/pptExport'
import ExportWmDialog from '../components/export-wm-dialog.vue'

export default {
  name: 'pptlist',
  components: { ExportWmDialog },
  data() {
    return {
      list: [],
      total: 0,
      query: { title: '', pageNum: 1, pageSize: 10 },
      previewVisible: false,
      previewLoading: false,
      previewPages: [],
      bigVisible: false,
      bigImg: '',
      bigIndex: 0,
      // 导出设置弹窗：wmKind=protected/verify，pendingDetail=待导出数据（取详情后才弹设置）
      wmDialogVisible: false,
      wmPreset: '',
      wmKind: 'protected',
      pendingDetail: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      // 注意：后端 getPptProjectPage 把实体 beginRow 字段当"页码"用（1 起），
      // 故这里传 beginRow=pageNum，而非偏移量；pageSize 照传。
      let params = { title: this.query.title || null, beginRow: this.query.pageNum, pageSize: this.query.pageSize }
      getPptProjectPage(params)
        .then((res) => {
          if (res.data.code === 0) {
            this.list = (res.data.data && res.data.data.value) || []
            this.total = (res.data.data && res.data.data.total) || 0
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((err) => this.$message.error('系统错误：' + err))
    },
    // 后端 Date 字段（update_date）序列化为毫秒时间戳，转 'yyyy-MM-dd HH:mm:ss' 展示（与工程旧页面一致）
    formateDate(datetime) {
      if (!datetime) return ''
      function addDateZero(num) {
        return num < 10 ? '0' + num : num
      }
      const d = new Date(datetime)
      if (isNaN(d.getTime())) return String(datetime)
      return d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' +
        addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds())
    },
    handleSearch() {
      this.query.pageNum = 1
      this.loadData()
    },
    // 整页图替换编辑：失真页用 PPT 截图整页替换（左侧缩略图 + 右侧大图）
    handleEdit(row) {
      this.$router.push({ path: '/pptedit', query: { id: row.id } })
    },
    // 预览检查：加载全部页面缩略图网格（不依赖发布状态）
    handlePreview(row) {
      this.previewLoading = true
      getPptProjectById(row.id)
        .then((res) => {
          if (res.data.code !== 0 || !res.data.data) {
            this.$message.error((res.data && res.data.message) || '获取项目详情失败')
            return
          }
          const p = res.data.data
          let pages = []
          try {
            pages = JSON.parse(p.pagesJson || '[]')
          } catch (e) {}
          if (!pages.length || !pages[0].img) {
            this.$message.warning('该项目没有可预览的渲染页面，请重新导入 .pptx 转换。')
            return
          }
          this.previewPages = pages
          this.previewVisible = true
        })
        .catch((err) => this.$message.error('预览失败：' + err))
        .finally(() => (this.previewLoading = false))
    },
    // 点击缩略图 → 放大查看该页
    previewBig(i) {
      if (!this.previewPages[i]) return
      this.bigIndex = i
      this.bigImg = this.previewPages[i].img
      this.bigVisible = true
    },
    // 大图弹窗内翻页
    previewNav(d) {
      const n = this.previewPages.length
      if (!n) return
      this.bigIndex = (this.bigIndex + d + n) % n
      this.bigImg = this.previewPages[this.bigIndex].img
    },
    // 导出共用前置：取详情并解析 pages/theme，失败提示并返回 null
    fetchExportDetail(row) {
      return getPptProjectById(row.id)
        .then((res) => {
          if (res.data.code !== 0 || !res.data.data) {
            this.$message.error((res.data && res.data.message) || '获取项目详情失败')
            return null
          }
          const p = res.data.data
          let pages = []
          try {
            pages = JSON.parse(p.pagesJson || '[]')
          } catch (e) {}
          if (!pages.length || !pages[0].img) {
            this.$message.warning('该项目没有可导出的渲染页面，请先重新导入 .pptx 转换。')
            return null
          }
          // 画布尺寸（pt）：hybrid 视频原位定位需要，缺省 16:9
          let pageW = 960
          let pageH = 540
          try {
            const theme = JSON.parse(p.themeJson || '{}')
            if (theme.pageW) pageW = Number(theme.pageW)
            if (theme.pageH) pageH = Number(theme.pageH)
          } catch (e) {}
          return { title: p.title || row.title || 'ppt', pages, pageW, pageH }
        })
        .catch((err) => {
          this.$message.error('导出失败：' + err)
          return null
        })
    },
    // 受保护版导出（资源进私有桶，页内只留钥匙，传 eOnline 平台用）：取详情 → 弹导出设置（可加水印）→ 导出
    async handleExportProtected(row) {
      const detail = await this.fetchExportDetail(row)
      if (!detail) return
      this.pendingDetail = detail
      this.wmKind = 'protected'
      this.wmPreset = ''
      this.openWmDialog()
    },
    // 验证版导出（自包含，本地双击验证用，勿上传 eOnline）：取详情 → 弹导出设置（默认带验证水印）→ 导出
    async handleExportVerify(row) {
      const detail = await this.fetchExportDetail(row)
      if (!detail) return
      this.pendingDetail = detail
      this.wmKind = 'verify'
      this.wmPreset = '验证专用·禁止上传'
      this.openWmDialog()
    },
    // 打开导出设置弹窗；弹窗已开着（点了另一行的导出）时手动重初始化表单，套用新类型默认值
    openWmDialog() {
      this.wmDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.wmDialog) this.$refs.wmDialog.initForm()
      })
    },
    // 导出设置确认：按打开弹窗时选定的类型执行导出，wm = { text, mode, corners, density }
    async onWmConfirm(wm) {
      const detail = this.pendingDetail
      if (!detail) return
      try {
        if (this.wmKind === 'verify') {
          await exportVerifyHtml(detail, { watermark: wm })
          this.$message.success('已导出验证版，可本地双击检查（勿上传 eOnline）')
        } else {
          await exportProtectedHtml(detail, { watermark: wm })
          this.$message.success('已导出受保护版，请上传 eOnline（本地打不开属正常）')
        }
      } catch (e) {
        this.$message.error('导出失败：' + ((e && e.message) || e))
      }
    },
    handleDelete(row) {
      this.$confirm(`确认删除 PPT「${row.title}」吗？`, '删除确认', { type: 'warning' })
        .then(() => {
          return deletePptProject(row.id)
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {})
    },
    pageCount(pagesJson) {
      try {
        const arr = JSON.parse(pagesJson || '[]')
        return Array.isArray(arr) ? arr.length : 0
      } catch (e) {
        return 0
      }
    },
    // 页型统计：动画页（sequence 关键帧）数量
    pageAnimCount(pagesJson) {
      try {
        return JSON.parse(pagesJson || '[]').filter((p) => p.type === 'sequence').length
      } catch (e) {
        return 0
      }
    },
    // 页型统计：视频页（hybrid 原位视频 / video 整页视频）数量
    pageVideoCount(pagesJson) {
      try {
        return JSON.parse(pagesJson || '[]').filter((p) => p.type === 'hybrid' || p.type === 'video').length
      } catch (e) {
        return 0
      }
    }
  }
}
</script>

<style scoped>
/* 页面整体高度适配外层 home 布局（系统头 + el-main 内边距 + 备案行），分页常驻底部可视 */
.mains { height: calc(100vh - 3.1vw - 104px); display: flex; flex-direction: column; }
.xiaoqu { flex: 1; min-height: 0; display: flex; flex-direction: column; }
.xiaoqu /deep/ .el-card { flex: 1; min-height: 0; display: flex; flex-direction: column; }
.xiaoqu /deep/ .el-card__body { flex: 1; min-height: 0; display: flex; flex-direction: column; }
.table-wrap { flex: 1; min-height: 0; overflow: auto; }
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
/* 预览网格 */
.preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 76vh;
  overflow-y: auto;
}
.preview-th {
  position: relative;
  width: 150px;
  flex-shrink: 0;
  cursor: pointer;
  border: 2px solid #e4e6eb;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  transition: border-color 0.15s;
}
.preview-th:hover {
  border-color: #2f9bff;
}
.preview-th img {
  display: block;
  width: 150px;
}
.preview-no {
  position: absolute;
  left: 4px;
  top: 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 8px;
}
.preview-empty {
  width: 100%;
  text-align: center;
  color: #909399;
  padding: 40px 0;
  font-size: 13px;
}
/* 大图查看 */
.big-stage {
  background: #22262b;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-height: 60vh;
}
.big-img {
  max-width: 100%;
  max-height: 82vh;
  object-fit: contain;
  display: block;
}
.big-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 10px;
}
.big-no {
  font-size: 14px;
  color: #606266;
  min-width: 90px;
  text-align: center;
}
</style>
